import { render } from "./GhostDraftView.vue?vue&type=template&id=660d7e72&scoped=true&ts=true"
import script from "./GhostDraftView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GhostDraftView.vue?vue&type=script&setup=true&lang=ts"

import "./GhostDraftView.vue?vue&type=style&index=0&id=660d7e72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660d7e72"],['__file',"src/components/GhostDraftView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "660d7e72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('660d7e72', __exports__)) {
    api.reload('660d7e72', __exports__)
  }
  
  module.hot.accept("./GhostDraftView.vue?vue&type=template&id=660d7e72&scoped=true&ts=true", () => {
    api.rerender('660d7e72', render)
  })

}


export default __exports__